var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { KeyboardArrowLeftRounded, KeyboardArrowRightRounded } from '@mui/icons-material';
import CustomSlider from '../geebee/CustomSlider';
var Slider = function (props) {
    var _a, _b, _c, _d;
    return (React.createElement(CustomSlider, __assign({}, props, { prevKeyClasses: (_a = props === null || props === void 0 ? void 0 : props.prevKeyClasses) !== null && _a !== void 0 ? _a : 'lfc--bottom-[15px] lfc-right-[75px] lfc-p-0', nextKeyClasses: (_b = props === null || props === void 0 ? void 0 : props.nextKeyClasses) !== null && _b !== void 0 ? _b : 'lfc--bottom-[15px] lfc-right-[30px] lfc-p-0', rightIcon: React.createElement(KeyboardArrowRightRounded, { className: "lfc-gray-700 lfc-text-[2rem]" }), leftIcon: React.createElement(KeyboardArrowLeftRounded, { className: "lfc-gray-700 lfc-text-[2rem]" }), activeDotColor: (_c = props === null || props === void 0 ? void 0 : props.activeDotColor) !== null && _c !== void 0 ? _c : '#443EFF', dotColor: (_d = props === null || props === void 0 ? void 0 : props.dotColor) !== null && _d !== void 0 ? _d : 'lfc-bg-[#F4EBFF]' })));
};
export default Slider;
//# sourceMappingURL=Slider.js.map